// extracted by mini-css-extract-plugin
export default {"Work":"Work_Work__8aiAA","Content":"Work_Content__XPG2l","WorkGrid":"Work_WorkGrid__uJoJU"};